<template>
  <div class="d d_cy">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">人次</li>
      <li class="u4-3">人数</li>
      <li class="u4-3">比例</li>
    </ul>
    <div class="cnt_list">
      <ul
        class="u4 u4_tit u_cy u9"
        v-for="(item, index) in formatData(list[type])"
        :key="index"
      >
        <li class="u4-3">{{ item.trainName }}</li>
        <li class="u4-3">{{ item.times }}</li>
        <li class="u4-3">{{ item.count }}</li>

        <li class="u4-3" v-if="list.schoolCounselorTrainingData">
          {{ percent(item.count, totalFn(list)) }}%
        </li>
        <li class="u4-3" v-if="list.chiefCounselorTrainingData">
          {{ percent(item.count, totalFn(list)) }}%
        </li>
      </ul>
    </div>

    <!-- <ul class="u4 u4_tit u_title u88">
      <li class="u4-3">选项</li>
      <li class="u4-3">人数</li>
      <li class="u4-3">比例</li>
    </ul> -->
    <!-- <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9">
        <li class="u4-3">3年内都未参加年度培训的</li>
        <li class="u4-3">{{ list.total - list.trainingNum }}</li>
        <li class="u4-3">
          {{ (((list.total - list.trainingNum) / list.total) * 100).toFixed(2) }}%
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { trainLevelList } from "@/common/js/field";
import _ from "lodash";
export default {
  name: "Train",
  props: {
    list: Object,
    type: String,
  },
  setup() {
    const totalFn = (list) => {
      const { schoolCounselorTrainingData, chiefCounselorTrainingData } = list;
      let newObj;
      if (!list) {
        return 0;
      }
      if (schoolCounselorTrainingData) {
        newObj = schoolCounselorTrainingData;
      }
      if (chiefCounselorTrainingData) {
        newObj = chiefCounselorTrainingData;
      }
      if (!newObj) {
        return 0;
      }
      const total = _.sumBy(newObj, function (o) {
        return o.count;
      });

      return total;
    };
    const formatData = (list = []) => {
      let arr = [];
      // 设置默认值
      for (let i of trainLevelList) {
        arr.push({
          count: 0,
          times: 0,
          train: 0,
          trainLevel: i.key,
          trainName: i.value,
        });
      }
      arr.push({
        count: 0,
        times: 0,
        train: 0,
        trainLevel: -1,
        trainName: "未参加",
      });

      if (list.length > 0) {
        // 如果大于0 修改默认值
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          const res = list.filter((res) => res.trainLevel == item.trainLevel);
          if (res.length > 0) {
            for (let r of res) {
              // times 次数
              // count 人数
              arr[i] = {
                ...arr[i],
                count: arr[i].count + r.count,
                times: arr[i].times + r.times,
              };
            }
          }
        }
      }
      return arr;
    };
    const percent = (value = 0, total = 0) => {
      if (value == 0 || total == 0) {
        return 0;
      }
      return ((value / total) * 100).toFixed(2);
    };
    return { trainLevelList, formatData, percent, totalFn };
  },
};
</script>

<style lang="less" scoped>
@import "@/common/style/mixin";

.u9 {
  background-color: #f8fafc;
  display: flex;
}
.u9:nth-child(2n + 1) {
  background-color: #fff;
}
.u_title {
  background-color: #e5e7eb;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
}
.u4_tit {
  height: auto;
  line-height: auto;
}
.u4_tit li {
  border-right: 1px solid #dcdcdc;
  margin-right: -1px;
}
.u4 li {
  width: 50%;
}
.total_title {
  font-size: 0.42rem;
  padding: 0.233rem;
}
.line {
  border-bottom: 1px dashed #dcdcdc;
  margin: 0.5rem 0;
}
.cnt_list {
  border: 1px solid #e5e7eb;
}
.u_cy li {
  min-height: auto;
  line-height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.u4_tit1 {
  border-right: none !important;
}
.u88 {
  margin-top: 10px;
}
</style>
